// {
//         "detail":
export  const stockData =  [
                {
                        "country": "Australia",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "new added",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 1,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "NULL",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2023,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2027,
                                        "adjustment": 0.56
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2028,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2032,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": 1,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 4.56,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Australia",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "test_may_1",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "None",
                                        "year": 2022,
                                        "adjustment": 0.01
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2024,
                                        "adjustment": 0.01
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2025,
                                        "adjustment": 0
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2026,
                                        "adjustment": 0.01
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2028,
                                        "adjustment": 0.01
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2030,
                                        "adjustment": 0.01
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2032,
                                        "adjustment": 0.01
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2023,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 1,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0.01,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0.01,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0.01,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0.01,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0.01,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0.01,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0.01,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0.01,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0.01,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0.01,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0.01,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0.01,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0.01,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0.01,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0.01,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0.01,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0.01,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0.01,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0.01,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0.01,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Australia",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "test_may_3",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "None",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2023,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2028,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "None",
                                        "year": 2032,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Australia",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "test_may_41",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "NULL",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2028,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2032,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2023,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Australia",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "test_may_42",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "NULL",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2028,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2032,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2023,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Canada",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "Canada_carb_test1",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "NULL",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2023,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2028,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2032,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Canada",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "Canada_carb_test2",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2023,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2028,
                                        "adjustment": 0.05
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2029,
                                        "adjustment": 0.05
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2030,
                                        "adjustment": 0.05
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "Adjusted increase",
                                        "year": 2032,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Canada",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "Canada_carb_test3",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": null,
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "Canada",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "test_A",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "NULL",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2023,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2028,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2032,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "market_momentum_weight",
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "Yes",
                                "variables": [
                                        "income_driver_weight",
                                        "aging_pop_driver_weight"
                                ]
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "CHN",
                        "category": "RTD Tea",
                        "economic_outlook": "Base",
                        "user_scenario": "test_now",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "NULL",
                                        "year": 2023,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2032,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2028,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "No"
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "No"
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                },
                {
                        "country": "ITA",
                        "category": "Carbonates",
                        "economic_outlook": "Base",
                        "user_scenario": "test_data",
                        "time_series_method": [
                                {
                                        "arima": 1
                                }
                        ],
                        "post_covid_recovery": [
                                {
                                        "covid_recovery": 0,
                                        "recovery_year": 2022
                                }
                        ],
                        "growth_limiting": [
                                {
                                        "limit_type": "NULL",
                                        "year": 2022,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2029,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2028,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2027,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2026,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2030,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2025,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2031,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2024,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2023,
                                        "adjustment": null
                                },
                                {
                                        "limit_type": "NULL",
                                        "year": 2032,
                                        "adjustment": null
                                }
                        ],
                        "category_level_pricing_adjustment": null,
                        "segment_level_pricing_adjustment": [
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2027,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2028,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2029,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2030,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2031,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2032,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2022,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2023,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2024,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                },
                                {
                                        "year": 2025,
                                        "adjustment": 0,
                                        "price_segment": "Premium"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Value"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core"
                                },
                                {
                                        "year": 2026,
                                        "adjustment": 0,
                                        "price_segment": "Core plus"
                                }
                        ],
                        "Macroeconomic_scenario": "Base Case",
                        "Category_model_driver_weights_adjustment": {
                                "difference": "No"
                        },
                        "S_curve_position_weights_adjustment": {
                                "difference": "No"
                        },
                        "Aging_population_driver_share_of_momentum_adjustment": {
                                "difference": "No"
                        }
                }, 
                {
                            "country": "Australia",
                            "category": "Carbonates",
                            "economic_outlook": "Base",
                            "user_scenario": "Australia_carb_test1",
                            "time_series_method": [
                                    {
                                            "arima": 0
                                    }
                            ],
                            "post_covid_recovery": [
                                    {
                                            "covid_recovery": 0,
                                            "recovery_year": 2022
                                    }
                            ],
                            "growth_limiting": [
                                    {
                                            "limit_type": "NULL",
                                            "year": 2027,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2031,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2022,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2024,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2025,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2026,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2028,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2029,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2030,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2032,
                                            "adjustment": null
                                    },
                                    {
                                            "limit_type": "NULL",
                                            "year": 2023,
                                            "adjustment": null
                                    }
                            ],
                            "category_level_pricing_adjustment": null,
                            "segment_level_pricing_adjustment": [
                                    {
                                            "year": 2032,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2032,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2032,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2032,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2031,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2031,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2031,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2031,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2030,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2030,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2030,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2030,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2029,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2029,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2029,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2029,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2028,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2028,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2028,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2028,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2027,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2027,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2027,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2027,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2026,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2026,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2026,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2026,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2025,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2025,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2025,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2025,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2024,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2024,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2024,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2024,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2023,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2023,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2023,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2023,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    },
                                    {
                                            "year": 2022,
                                            "adjustment": 0,
                                            "price_segment": "Premium"
                                    },
                                    {
                                            "year": 2022,
                                            "adjustment": 0,
                                            "price_segment": "Core plus"
                                    },
                                    {
                                            "year": 2022,
                                            "adjustment": 0,
                                            "price_segment": "Core"
                                    },
                                    {
                                            "year": 2022,
                                            "adjustment": 0,
                                            "price_segment": "Value"
                                    }
                            ],
                            "Macroeconomic_scenario": "Base Case",
                            "Category_model_driver_weights_adjustment": {
                                    "difference": "Yes",
                                    "variables": [
                                            "market_momentum_weight",
                                            "income_driver_weight",
                                            "aging_pop_driver_weight"
                                    ]
                            },
                            "S_curve_position_weights_adjustment": {
                                    "difference": "Yes",
                                    "variables": [
                                            "income_driver_weight",
                                            "aging_pop_driver_weight"
                                    ]
                            },
                            "Aging_population_driver_share_of_momentum_adjustment": {
                                    "difference": "No"
                            }
                },
        ]
// ,
//         "meta": {
//                 "message": "Success Message",
//                 "code": 200
//         }
// }